import { useState } from "react";
import { successNotify, errorNotify } from "../../../Services/Notification";
import axios from "axios";
import { fileUploadIcon } from "../../../assetData/icons";
import MirageLoader from "../../ui/pageLoader/MirageLoader";

const ImportSchemePopup = ({ isOpen, onClose, url, title }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "multipart/form-data",
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type if needed (e.g., only .txt files)
      if (!file.name.endsWith(".txt") && !file.name.endsWith(".xlsx")) {
        setSelectedFile(null);
        return;
      }
      setSelectedFile(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedFile) {
      errorNotify("Please select a file to upload");
      return;
    }

    setIsUploading(true);

    try {
      const formData = new FormData();
      formData.append("file", selectedFile);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}api/${url}`,
        formData,
        { headers },
      );
      if (!response?.data?.error) {
        successNotify(response?.data?.message);
        handleClose();
      } else {
        errorNotify(response?.data?.message);
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        "An error occurred while uploading the file";
      errorNotify(errorMessage);
    } finally {
      setIsUploading(false);
    }
  };

  const handleClose = () => {
    setSelectedFile(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-neutral-800">{title}</h2>
          <button
            onClick={handleClose}
            className="text-neutral-500 hover:text-neutral-700"
            disabled={isUploading}
          >
            <svg
              className="h-6 w-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <div className="relative overflow-hidden rounded-lg max-md:w-full md:w-full">
              <input
                disabled={isUploading}
                type="file"
                className="custom-doc-uploader  bg-[#f0f0f0] text-neutral-600"
                onChange={handleFileChange}
              />
              <img
                src={fileUploadIcon}
                className="absolute left-4 top-1/2 z-10 -translate-y-1/2"
              />
            </div>
          </div>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={handleClose}
              className="rounded border border-neutral-300 px-4 py-2 text-sm font-medium text-neutral-700 hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-neutral-500"
              disabled={isUploading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="hover:bg-pri-clr-orange-700 focus:ring-pri-clr-orange-500 rounded bg-pri-clr-orange px-4 py-2 text-sm font-medium text-white focus:outline-none focus:ring-2 disabled:cursor-not-allowed disabled:opacity-50"
              disabled={isUploading || !selectedFile}
            >
              {isUploading ? <MirageLoader /> : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ImportSchemePopup;
